// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// RxJs imports
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
// Service import
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { BoardApprovalAllowedActionsResultDto } from '../_models/board-approval-allowed-actions-result-dto';
import { BoardApprovalQueueResultDto } from '../_models/board-approval-queue-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class BoardApprovalService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
        this._subjectUpdateBoardApproval = new Subject();
    }
    getBoardApprovalQueue(baseParams) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/queue${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(BoardApprovalQueueResultDto, response)));
    }
    getActions(baseParams) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/actions${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(BoardApprovalAllowedActionsResultDto, response)));
    }
    approveMultipleBoardApprovalAcc(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/acc/multi-select/action/approve`;
        return this.httpClient.post(url, classToPlain(params));
    }
    denyMultipleBoardApprovalAcc(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/acc/multi-select/action/deny`;
        return this.httpClient.post(url, classToPlain(params));
    }
    holdMultipleBoardApprovalAcc(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/acc/multi-select/action/hold`;
        return this.httpClient.post(url, classToPlain(params));
    }
    approveMultipleWithStipulationBoardApprovalAcc(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/acc/multi-select/action/approve-with-stipulation`;
        return this.httpClient.post(url, classToPlain(params));
    }
    /* services for boardapproval/acc ends here */
    /* services for boardapproval/collections starts here */
    approveMultipleBoardApprovalCollection(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/collections/multi-select/action/approve`;
        return this.httpClient.post(url, classToPlain(params));
    }
    denyMultipleBoardApprovalCollection(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/collections/multi-select/action/deny`;
        return this.httpClient.post(url, classToPlain(params));
    }
    holdMultipleBoardApprovalCollection(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/collections/multi-select/action/hold`;
        return this.httpClient.post(url, classToPlain(params));
    }
    approveMultipleWithStipulationBoardApprovalCollection(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/collections/multi-select/action/approve-with-stipulation`;
        return this.httpClient.post(url, classToPlain(params));
    }
    /* services for boardapproval/collections ends here */
    /* services for boardapproval/wf starts here */
    approveMultipleBoardApprovalWf(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/wf/multi-select/action/approve`;
        return this.httpClient.post(url, classToPlain(params));
    }
    denyMultipleBoardApprovalWf(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/wf/multi-select/action/deny`;
        return this.httpClient.post(url, classToPlain(params));
    }
    holdMultipleBoardApprovalWf(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/wf/multi-select/action/hold`;
        return this.httpClient.post(url, classToPlain(params));
    }
    approveMultipleWithStipulationBoardApprovalWf(params) {
        const url = `${URLConstants.ccBoardApprovalConfigApiUrl}/wf/multi-select/action/approve-with-stipulation`;
        return this.httpClient.post(url, classToPlain(params));
    }
    /* services for boardapproval/wf ends here */
    /* Others */
    updateBoardApprovalRecords() {
        this._subjectUpdateBoardApproval.next(true);
    }
    refreshBoardApprovalRecords() {
        return this._subjectUpdateBoardApproval;
    }
}
BoardApprovalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BoardApprovalService_Factory() { return new BoardApprovalService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: BoardApprovalService, providedIn: "root" });
